import { CloseIcon, SearchIcon } from '@chakra-ui/icons'
import {
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  chakra,
} from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import { AnalyticsAction, analyticsAction } from '../../common/utils/analytics'
interface SearchInputProps {
  onSearch: (value: string) => void
  placeholder?: string
  className?: string
  initialValue?: string
  action?: AnalyticsAction
}

const SearchInput: React.FC<SearchInputProps> = ({
  onSearch,
  placeholder,
  className,
  initialValue = '',
  action,
}) => {
  const [search, setSearch] = useState(initialValue)

  // Update internal state when initialValue changes
  useEffect(() => {
    setSearch(initialValue)
  }, [initialValue])

  const handleSearch = () => {
    const value = search.trim()
    onSearch(value)
  }

  const handleClear = () => {
    setSearch('')
    onSearch('')
  }

  return (
    <InputGroup className={className} variant="outline">
      <InputLeftElement cursor="pointer" onClick={handleSearch}>
        <SearchIcon />
      </InputLeftElement>
      <Input
        maxWidth="100%"
        placeholder={`Search ${placeholder || ''}`}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSearch()
          }
        }}
        focusBorderColor="blue.500"
        backgroundColor="white"
        {...(action && analyticsAction(action))}
      />
      {search && (
        <InputRightElement>
          <IconButton
            aria-label="Clear search"
            icon={<CloseIcon boxSize={3} />}
            size="sm"
            variant="ghost"
            color="gray.500"
            onClick={handleClear}
          />
        </InputRightElement>
      )}
    </InputGroup>
  )
}

export default chakra(SearchInput)
